var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wrapClasses)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{class:_vm.wrapClasses},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.rawhtml)}})])])]):_c('div',{},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.rawhtml)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-349d4341","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextBlock.vue
// module id = 473
// module chunks = 1